var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"d-flex justify-content-center"},[_c('apexchart',{attrs:{"type":"donut","options":_vm.SummaryNotadinasCategory,"series":_vm.series,"width":"380","height":"380"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }